export const errorRequestInterceptor = (error) => {
  return Promise.reject(error);
};
